import React, { useState } from 'react';

const Brochure = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  // ✅ Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Send email (no redirect)
    fetch("https://formsubmit.co/ajax/contact@enessafoods.com", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        Name: formData.name,
        Email: formData.email,
        Phone: formData.phone,
        _subject: "Brochure Download Request"
      })
    }).catch(err => console.log(err));

    // ✅ Download PDF (IMPORTANT PATH)
    const link = document.createElement('a');
    link.href = '/brochure/Brochure.pdf'; // 👉 make sure file exists here
    link.download = 'Enessa-Foods-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // reset
    setShowModal(false);
    setFormData({ name: '', email: '', phone: '' });
  };

  return (
    <>
      {/* ✅ BUTTON */}
      <button
        onClick={() => setShowModal(true)}
        className="px-6 py-3 bg-[#b42b2b] text-white rounded-full"
      >
        Download Brochure
      </button>

      {/* ✅ MODAL */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white p-6 rounded-xl w-[400px]"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold mb-4">
              Download Brochure
            </h2>

            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="text"
                placeholder="Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                className="w-full border p-2 rounded"
                required
              />

              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="w-full border p-2 rounded"
                required
              />

              <input
                type="tel"
                placeholder="Phone"
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                className="w-full border p-2 rounded"
                required
              />

              <div className="flex gap-2">
                <button
                  type="submit"
                  className="bg-[#b42b2b] text-white px-4 py-2 rounded"
                >
                  Download
                </button>

                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="bg-gray-300 px-4 py-2 rounded"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Brochure;